import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CompensationCalculator } from './CompensationCalculator';
import type { ClaimType } from '../types/claimCalculator';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/e7d86470-e873-49c0-b96f-eb28a583b88b.jpg';
const results = [{
  value: '35+',
  label: 'Years of experience'
}, {
  value: "1000's",
  label: 'Claims successfully settled'
}, {
  value: '98%',
  label: 'Claim success rate'
}];
const trustPoints = ['4.7 Google rating from around 300 reviews', 'No win, no fee', 'Approved claim costs funded while your claim runs', 'Proudly WA founded and owned'];
interface HeroProps {
  calculatorStep?: number;
  calculatorClaimType?: ClaimType;
}
export function Hero({
  calculatorStep = 0,
  calculatorClaimType = 'road'
}: HeroProps) {
  return <section className="w-full overflow-hidden bg-paper" data-id="element-306" data-mp="3d2tqpg8vwwhp">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-start gap-10 px-5 pb-10 pt-6 sm:px-6 md:pb-12 md:pt-8 lg:grid-cols-[0.94fr_1.06fr] lg:gap-12 lg:px-8 lg:pb-8 lg:pt-8" data-id="element-307" data-mp="3825xqp13i5ku">
        <div className="relative z-10" data-id="element-308" data-mp="3o85ata00nz41">
          <h1 className="max-w-2xl font-serif font-medium leading-[1.05] tracking-[-0.02em] text-forest" data-id="element-309" data-mp="3o73qeex4209n">
            <span className="block text-[26px] sm:text-[30px] lg:text-[32px]" data-id="element-310" data-mp="39a38f34q1jod">
              Separovic Injury Lawyers
            </span>
            <span className="mt-1 block text-[34px] leading-[1.04] tracking-[-0.025em] sm:text-[40px] lg:text-[44px]" data-id="element-311" data-mp="30iayctjm0ckb">
              Leading Perth Injury Law Specialists
            </span>
          </h1>

          <ul className="mt-4 space-y-1 text-[16px] font-semibold leading-[1.4] text-ink sm:text-[17px]" data-id="element-312" data-mp="2qk3hsbt8fwiu">
            <li data-id="element-313" data-mp="2vievixmner6c">Trusted in WA since 1990</li>
            <li data-id="element-314" data-mp="2vj7uhcfd8cdx">Expert car accident lawyers</li>
            <li data-id="element-315" data-mp="2hinaicxpsaiu">Expert work accident lawyers</li>
          </ul>

          <p className="mt-5 max-w-xl text-body leading-[1.6] text-ink" data-id="element-316" data-mp="2hl9r122l20d7">
            Get clear, friendly advice in plain English, from a highly
            experienced injury lawyer who will explain where you stand, the
            potential value of your claim, and the next steps in the claim
            process.
          </p>

          <dl className="mt-6 grid grid-cols-3 overflow-hidden rounded-card border border-ink/8 bg-canvas shadow-card" data-id="element-317" data-mp="ibyoi9esyw0l">
            {results.map((result, index) => <div key={result.label} className={`flex min-w-0 flex-col justify-center px-2.5 py-4 sm:px-4 ${index > 0 ? 'border-l border-ink/8' : ''}`} data-id="element-318" data-mp="db2fjhflgjob" data-mpi={index}>
                <dt className="order-2 mt-1 text-[10px] font-semibold leading-[1.35] text-slate sm:text-[13px]" data-id="element-319" data-mp="1126mkd3naw9x">
                  {result.label}
                </dt>
                <dd className="order-1 whitespace-nowrap font-serif text-[19px] font-semibold leading-none tracking-[-0.02em] text-forest sm:text-[27px]" data-id="element-320" data-mp="x3h0zx8ge8f7">
                  {result.value}
                </dd>
              </div>)}
          </dl>

          <ul className="mt-5 space-y-2.5 rounded-card bg-warm-tint px-4 py-4 sm:px-5" data-id="element-321" data-mp="1xam5iqqvrqyx">
            {trustPoints.map(point => <li key={point} className="flex items-start gap-3" data-id="element-322" data-mp="218tl3i9lym8j">
                <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-forest" strokeWidth={2} aria-hidden="true" data-id="element-323" data-mp="2697o2lwcr5zp" />
                <span className="text-[15px] font-semibold leading-[1.45] text-forest" data-id="element-324" data-mp="2fyr7ptrw33vm">
                  {point}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="relative mx-auto w-full max-w-xl lg:mx-0 lg:justify-self-end" data-id="element-325" data-mp="2p1jzrz8wbjmi">
          <div className="relative aspect-[3/2] overflow-hidden rounded-frame bg-forest shadow-card-lg" data-id="element-326" data-mp="2tztts6ivwe6j">
            <img src={HERO_IMAGE} alt="Emergency rescue workers helping an injured woman from a severely damaged car after a collision" width={1264} height={884} loading="eager" className="absolute inset-0 h-full w-full object-cover object-center" data-id="element-327" data-mp="unj0jd9foulw" />
          </div>

          <div className="relative z-10 mx-2 -mt-20 sm:ml-auto sm:mr-4 sm:w-[390px] lg:-mt-24" data-id="element-328" data-mp="e9jxju49n9rw">
            <CompensationCalculator initialStep={calculatorStep} initialClaimType={calculatorClaimType} data-id="element-329" data-mp="9ah4z95h2w0t" />
          </div>
        </div>
      </div>
    </section>;
}